export const ScheduleData ={
    
    options:[
        { key:'1', dayName: 'יום א', date:'24/03/2012 17:45:12' , startTime:'08:00',endTime: '09:00'},
        { key:'2', dayName: 'יום א', date:'24/03/2012 17:45:12' , startTime:'09:00',endTime: '09:00'},
        { key:'3', dayName: 'יום ג', date:'25/03/2012 17:45:12' , startTime:'08:00',endTime: '09:00'},
        { key:'4', dayName: 'יום ד', date:'26/03/2012 17:45:12' , startTime:'08:00',endTime: '09:00'},
        { key:'5', dayName: 'יום ה', date:'27/03/2012 17:45:12' , startTime:'08:00',endTime: '09:00'}
    ]
}
